module.exports = __webpack_public_path__ + "static/Solution_Ad4-14b4b60b0a0aa8024a81bf25181133dc.png";